import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ServiceManagerBase } from '../common/service-manager-base';
import { BroadcastService } from '../../core/services/broadcast.service';

import { Album } from './album.model';
import { AlbumApiService } from './album-api.service';
import { tap } from 'rxjs/operators';
import { ImageAsset } from '../images/image-asset-model';
import { MyApp } from '../common/enumerations';

@Injectable({
    providedIn: 'root'
})
export class AlbumManagerService extends ServiceManagerBase
{
    private _favorites: Album;

    constructor(private albumApiService: AlbumApiService,
                protected broadcastService: BroadcastService)
    {
        super(broadcastService);
    }

    clearCache()
    {
        this._favorites = null;
    }

    favorites(): Observable<Album>
    {
        if (this._favorites != null) { return of(this._favorites); }
        return this.albumApiService.getAlbum(-1, false).pipe(tap(album => this._favorites = album));
    }

    // Note: parentAlbumId = 0 for top-level
    getAlbum(id: number, breadcrumbs: boolean = false): Observable<Album>
    {
        return this.albumApiService.getAlbum(id, breadcrumbs);
    }

    favoriteAdded(imageAsset: ImageAsset)
    {
        if (this._favorites == null) return;
        if (this._favorites.ImageAssets == null) this._favorites.ImageAssets = [];
        this._favorites.ImageAssets.push(imageAsset);
        this._favorites.ImageAssets.sort((ia1, ia2) => ia1.CreatedOn < ia2.CreatedOn ? 1 : -1);
        if (imageAsset.AssetType === MyApp.AssetType.Image) this._favorites.PhotosCount++;
        else if (imageAsset.AssetType === MyApp.AssetType.Video) this._favorites.VideosCount++;
    }

    favoriteDeleted(imageAsset: ImageAsset)
    {
        if (this._favorites == null) return;
        if (this._favorites.ImageAssets == null) this._favorites.ImageAssets = [];
        this._favorites.ImageAssets = this._favorites.ImageAssets.filter(ia => ia.Id !== imageAsset.Id);
        if (imageAsset.AssetType === MyApp.AssetType.Image) this._favorites.PhotosCount--;
        else if (imageAsset.AssetType === MyApp.AssetType.Video) this._favorites.VideosCount--;
    }
}
